import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import type {
  TypedSchemaInput,
  TypedSchemaOutput,
} from "@/utils/typeUtilities"
import {
  requiredTrimmedString,
  trimmedString,
} from "@/forms/validation/stringFieldSchemas"

const productFormSchema = z.object({
  name: requiredTrimmedString("Product name is required"),
  price: z.number().int().nonnegative(),
  color: trimmedString().nullable(),
  vatRate: z
    .number()
    .multipleOf(
      0.01,
      "VAT rate must have at most 2 decimal places"
    )
    .nullable(),
  parentCategoryId: z.string().uuid().nullable(),
  hasVariablePrice: z.boolean(),
})

export type ProductFormInput = TypedSchemaInput<
  typeof productFormSchema
>
export type ProductFormOuput = TypedSchemaOutput<
  typeof productFormSchema
>

export const useProductForm = () =>
  useForm({
    validationSchema: toTypedSchema(productFormSchema),
    initialValues: {
      name: "",
      price: 0,
      color: null,
      parentCategoryId: null,
      vatRate: null,
      hasVariablePrice: false,
    },
  })
